import { render, staticRenderFns } from "./uniformList.vue?vue&type=template&id=606ed448&scoped=true&"
import script from "./uniformList.vue?vue&type=script&lang=js&"
export * from "./uniformList.vue?vue&type=script&lang=js&"
import style0 from "./uniformList.vue?vue&type=style&index=0&id=606ed448&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ed448",
  null
  
)

export default component.exports